import digitalData from 'digital-data';
export const loyaltyBenefits = () => {
  const pageEvents = {
    buttonClick: _ref => {
      let {
        output
      } = _ref;
      const {
        settings
      } = output;
      digitalData.event = (digitalData === null || digitalData === void 0 ? void 0 : digitalData.event) || [];
      digitalData.event.push({
        eventInfo: {
          eventName: 'my account settings'
        },
        category: {
          primaryCategory: 'button submission'
        },
        myAccount: {
          settings
        }
      });
    },
    stash: _ref2 => {
      let {
        output
      } = _ref2;
      const {
        settings
      } = output;
      digitalData.event = (digitalData === null || digitalData === void 0 ? void 0 : digitalData.event) || [];
      digitalData.event.push({
        eventInfo: {
          eventName: 'my account settings'
        },
        eventMode: 'stash',
        category: {
          primaryCategory: 'stash'
        },
        stash: {
          myAccount: {
            settings
          }
        }
      });
    },
    overlay: _ref3 => {
      let {
        output
      } = _ref3;
      const {
        settings
      } = output;
      digitalData.event = (digitalData === null || digitalData === void 0 ? void 0 : digitalData.event) || [];
      digitalData.event.push({
        eventInfo: {
          eventName: settings
        },
        category: {
          primaryCategory: 'overlay'
        }
      });
    }
  };
  window.LIFE_CYCLE_EVENT_BUS.on('loyalty-benefits.loyalty-button', pageEvents.buttonClick);
  window.LIFE_CYCLE_EVENT_BUS.on('loyalty-benefits.loyalty-stash', pageEvents.stash);
  window.LIFE_CYCLE_EVENT_BUS.on('loyalty-benefits.loyalty-overlay', pageEvents.overlay);
};
//# sourceMappingURL=loyalty-benefits.listener.analytics.js.map